export default __webpack_public_path__ + "static/media/IMG_9976.e7abf43c.jpg";